class ShowMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cta = this.querySelector('.show-more-cta');
    if (!this.cta) return;

    this.cta.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const hiddenItems = this.querySelectorAll('.hidden');

    hiddenItems.forEach(el => {
      el.classList.remove('hidden');
    });

    // убрать кнопку после клика
    this.cta.remove();

    // если нужно вместо удаления:
    // this.cta.textContent = 'Show less';
  }
}

customElements.define('show-more', ShowMore);
